import { FLIGHT_OF_THE_DAY_DECORATION } from 'clientState/ab/aliases';
import ThreeColumnsItineraryDecorationBase from '@components/Results/Components/ThreeColumnsItinerary/ThreeColumnsItineraryDecoration/ThreeColumnsItineraryDecorationBase';
import ThreeColumnsItineraryDecorationRevamp from '@components/Results/Components/ThreeColumnsItinerary/ThreeColumnsItineraryDecoration/ThreeColumnsItineraryDecorationRevamp';
import { createFeature } from '@edreamsodigeo/frontend-core';

export const ThreeColumnsItineraryDecoration = createFeature({
  name: FLIGHT_OF_THE_DAY_DECORATION,
  variations: [
    ThreeColumnsItineraryDecorationBase,
    ThreeColumnsItineraryDecorationRevamp,
    ThreeColumnsItineraryDecorationRevamp,
  ],
  version: 1,
});
